import React, { useEffect } from "react";

import Navbar from "../../Components/Common/navbar";
import PackageDetailSection from "./packageDetailSection";
import { useParams, useSearchParams } from "react-router-dom";
import { getNextFriday, getNextSaturday } from "../../common/utils/dateUtil";
import { Container } from "../../Components/Common/Tailwind";
import moment from "moment";
import { Link } from "react-router-dom";
import MobileViewContainer from "../../Components/MobileViewContainer";
import { ChevronLeft } from "lucide-react";

export function LodgingPackageDetailPage() {
    const { id } = useParams();
    if (!id) return null;

    return (
        <MobileViewContainer>
            <div className="mt-4 mb-4 px-4">
                <div className="relative flex items-center justify-center h-9">
                    <Link to="/lodging-package" className="absolute left-0 flex items-center text-base font-bold text-black no-underline" aria-label="뒤로가기">
                        <ChevronLeft size={22} />
                    </Link>
                    <h1 className="text-lg font-bold text-black">예약상세</h1>
                </div>
            </div>

            <Container className="justify-center" style={{ minHeight: "100vh" }}>

                <div className="pt-4">
                    {/* Date Picker Removed */}
                </div>

                <PackageDetailSection id={id} />

            </Container>
        </MobileViewContainer>
    );
}
